var map = {
	"./careers/careers_video_poster.png": "5f7f",
	"./careers/desktop_careers_top_img.jpg": "c423",
	"./careers/mobile_careers_top_img.jpg": "8466",
	"./contact/Boston.jpg": "203a",
	"./contact/DF_cell_illustration_desktop.jpg": "0665",
	"./contact/DF_cell_illustration_mobile.jpg": "5aa8",
	"./contact/Shanghai.png": "51d4",
	"./contact/Zhejiang.jpg": "407c",
	"./contact/old_Boston.jpg": "95b5",
	"./contact/old_Shanghai.png": "c513",
	"./footer/1-CN-Internet-Licenses-Logo.png": "fb82",
	"./footer/2-CN-Licenses-Logo.png": "2ee0",
	"./footer/Drug_Farm_old_logo.svg": "f3ce",
	"./header/DF_burger_icon.png": "8cbd",
	"./header/DF_exit_icon.png": "9d18",
	"./header/DF_logo.svg": "1270",
	"./home/Chemistry.svg": "448e",
	"./home/DF_desk_blue_arrow.svg": "0d63",
	"./home/DF_plus_grey.svg": "d659",
	"./home/Genetics.svg": "b21b",
	"./home/Technology.svg": "786a",
	"./home/home-main.png": "19cf",
	"./modal/DF_white_arrow_left_desktop.svg": "4c5f",
	"./modal/DF_white_arrow_right_desktop.svg": "b812",
	"./news/desktop_news_top_img.jpg": "84ed",
	"./news/mobile_news_top_img.jpg": "1e0f",
	"./pipeline/desktop_pipeline_top_img.jpg": "1c27",
	"./pipeline/mobile_pipeline_top_img.jpg": "ccd1",
	"./platform/IDInVivo+_logo.png": "389c",
	"./platform/Medchem5_logo.png": "bf7c",
	"./platform/desktop_platform_top_img.jpg": "c8d5",
	"./platform/medchem5_illustration_desktop.png": "0aa9",
	"./platform/medchem5_illustration_mobile.jpg": "7be4",
	"./platform/mobile_platform_top_img.png": "ab9e",
	"./platform/mouse_illustration_desktop.png": "91c3",
	"./platform/mouse_illustration_mobile.png": "d8e2",
	"./publications/1_Cell_cover_story.jpg": "88dc",
	"./publications/2_Nucleic_Acids_Research_cover.jpg": "58d6",
	"./publications/3_Disease_models_and_mechanisms_cover.jpg": "0c75",
	"./publications/5_Cell_cover.jpg": "bdc1",
	"./publications/6_PNAS_cover.jpg": "6ff9",
	"./publications/7_Stem_cell_reports_cover.jpg": "2309",
	"./publications/8_International_journal_of_biological_sciences_cover.jpg": "d6f7",
	"./publications/9_Science_cover.jpg": "0a3c",
	"./publications/AASLD2024.jpg": "969d",
	"./publications/AASLD2024.pdf": "d800",
	"./publications/APVRS2026.png": "7d70",
	"./publications/ARVO2026.pdf": "865a",
	"./publications/ARVO2026.png": "3dbf",
	"./publications/ASCPT2025.jpg": "8907",
	"./publications/ASCPT2025.pdf": "7e6e",
	"./publications/ASN2026.png": "80c8",
	"./publications/EASL.jpg": "54cd",
	"./publications/EASL2024.jpg": "070f",
	"./publications/EASL2024.pdf": "c784",
	"./publications/Hepatology202206.jpg": "5548",
	"./publications/Hepatology202206_incert.jpg": "1fb5",
	"./publications/IMMUNOLOGY2026.jpg": "6f7d",
	"./publications/Nature_Biomedical_Engineering_2025.png": "0a7c",
	"./publications/Nature_Biomedical_Engineering_Cover_Article.png": "48f2",
	"./publications/Nature_Communications_2025.jpg": "28ac",
	"./publications/Nature_Communications_2025.pdf": "b56e",
	"./publications/bioRxiv_logo.png": "9e80",
	"./publications/desktop_publications_top_img.jpg": "a00b",
	"./publications/mobile_publications_img.jpg": "a472",
	"./team/Carl_Cook.png": "2418",
	"./team/Cong_Tony_XU.png": "0f07",
	"./team/Daniel_Starczynowski.png": "c214",
	"./team/Danyang_Liu.png": "de9a",
	"./team/Eshwari_Kovoor.png": "6517",
	"./team/Henri_Lichenstein.png": "678d",
	"./team/Huaixin_Dang.png": "45a3",
	"./team/Jeysen_Yogaratnam.png": "f0ba",
	"./team/Jian_Li.png": "3e04",
	"./team/Jianguang_Lei.png": "2d8f",
	"./team/Jieqing_Fan.png": "0c7b",
	"./team/Jonathan_Wang.png": "da40",
	"./team/Jonathan_Wang.png.original": "f5f8",
	"./team/Juan_Carlos.png": "deca",
	"./team/Julie_Clifford.png": "c30e",
	"./team/Jun_Yin.png": "75f1",
	"./team/Keith_Fandrick.png": "1e13",
	"./team/Ken_Truitt.png": "6b2b",
	"./team/Leong_Goh.png": "434d",
	"./team/Lishan_Su.png": "245c",
	"./team/Mary_Ellen_Cosenza.png": "3c9b",
	"./team/Mary_Scott.png": "c313",
	"./team/Neil_Solomons.png": "fb76",
	"./team/Noelia_Rycerz.png": "6aaa",
	"./team/Robert_Zhao.png": "d2c1",
	"./team/Sicong_Geng.png": "ff08",
	"./team/Susan_Parker.png": "9bf1",
	"./team/Tian_Xu.png": "6560",
	"./team/Ya_Chao_(Rachel)_Zhao.png": "68cc",
	"./team/Yiming_Li.png": "c004",
	"./team/Zhang_Yue.png": "d38b",
	"./team/Zhijian_James_Chen.png": "06ca",
	"./team/desktop_team_top_img.jpg": "4901",
	"./team/mobile_team_top_img.jpg": "d2d2",
	"./video/DF_homepage_video.mp4": "78a5",
	"./video/Drug_Farm_Video.mp4": "8978"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";